<template>
  <Modal
    :modal="objectiveDescriptionModalRef"
    :steps="[{ component: ObjectiveDescriptionModalContent, id: 'objective-description' }]"
  />
</template>

<script lang="ts" setup>
import ObjectiveDescriptionModalContent from '@/features/programs/components/objective-description-modal/objective-description-modal-content/objective-description-modal-content.vue'
import Modal from '@/features/ui/components/modal/modal.vue'
import { selectGetObjectiveDescriptionModal } from '@/features/ui/store/modal/modal.selectors'
import modalsStore from '@/features/ui/store/modal/modal.store'

const objectiveDescriptionModalRef = selectGetObjectiveDescriptionModal(modalsStore)
</script>
